import { render, staticRenderFns } from "./ExpiredUrlConfirmation.vue?vue&type=template&id=6fc0e814&scoped=true&"
import script from "./ExpiredUrlConfirmation.vue.js?vue&type=script&lang=js&"
export * from "./ExpiredUrlConfirmation.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc0e814",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
